/** Java Long으로 표현 가능한 가장 큰 양의 예약 ID입니다. */
const JAVA_LONG_MAX = '9223372036854775807';

/** 화면 표시용 이름·직급의 과도한 길이를 제한합니다. */
const AUTHOR_TEXT_MAX_LENGTH = 100;

/** 앞뒤·연속 공백을 정리하고 최대 표시 길이를 적용합니다. */
function normalizeAuthorText(value) {
  if (typeof value !== 'string') return '';
  return value.trim().replace(/\s+/g, ' ').slice(0, AUTHOR_TEXT_MAX_LENGTH);
}

/**
 * 작성자 표시 문자열과 스크린리더용 이름을 함께 만듭니다.
 * 이름이 없으면 직급만 단독 노출하지 않고, 직급이 없으면 구분자도 만들지 않습니다.
 */
export function formatChatAuthor(name, position, positionLabel) {
  const normalizedName = normalizeAuthorText(name);
  const normalizedPosition = normalizeAuthorText(position);
  if (!normalizedName) return { visual: '', accessible: '' };
  if (!normalizedPosition) {
    return { visual: normalizedName, accessible: normalizedName };
  }

  return {
    visual: `${normalizedName}/${normalizedPosition}`,
    accessible: `${normalizedName}, ${positionLabel} ${normalizedPosition}`,
  };
}

/** 양의 10진 정수이며 Java Long 범위인 예약 ID만 라우트에 사용합니다. */
export function normalizeReservationId(value) {
  const candidate = String(value ?? '').trim();
  if (!/^[1-9]\d*$/.test(candidate)) return null;

  // Number 변환은 64비트 정밀도를 잃으므로 자릿수와 사전식 비교로 범위를 판정합니다.
  if (candidate.length < JAVA_LONG_MAX.length) return candidate;
  if (candidate.length > JAVA_LONG_MAX.length) return null;
  return candidate <= JAVA_LONG_MAX ? candidate : null;
}

/** PC 문의 상세 화면의 기존 쿼리 라우트를 안전하게 생성합니다. */
export function buildDesktopInquiryPath(reservationId) {
  const normalizedId = normalizeReservationId(reservationId);
  return normalizedId ? `/inquiry?id=${normalizedId}` : null;
}

/**
 * 채팅 창 이동값을 뷰포트 안으로 제한합니다.
 * origin은 transform을 제외한 창의 원래 좌상단이며, 네 변에 최소 margin을 남깁니다.
 */
export function clampChatOffset(requested, origin, size, viewport, margin = 8) {
  const minX = margin - origin.left;
  const maxX = viewport.width - margin - origin.left - size.width;
  const minY = margin - origin.top;
  const maxY = viewport.height - margin - origin.top - size.height;

  return {
    x: Math.min(Math.max(requested.x, Math.min(minX, maxX)), Math.max(minX, maxX)),
    y: Math.min(Math.max(requested.y, Math.min(minY, maxY)), Math.max(minY, maxY)),
  };
}
